import { Tabs } from '@mantine/core';
import { useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom';

import { isScautrAiAgentEnabled } from '../../../../../../shared/utils/aiAgentServiceChannel';

import { buildSearchString } from '../../utils/buildSearchString';
import { useGetCompanyDetails } from '../../../../../../shared/apis/company/reactQueries';

export default function AiAgentTabs() {
  const [searchParams] = useSearchParams();
  const params = useParams();
  const { companyId } = params;
  const { pathname } = useLocation();
  const companyName = searchParams.get('companyName') || '';
  const navigate = useNavigate();
  const activeTab = pathname.includes('/manual')
    ? 'manual'
    : pathname.includes('/template')
      ? 'template'
      : pathname.includes('/ascs')
        ? 'ascs'
        : 'model';

  const handleTabChange = (value: string | null) => {
    if (value) {
      const nextPath = `/admin/management/aiagent/company/${companyId}/${value}`;

      navigate(
        `${nextPath}${buildSearchString({
          companyName,
        })}`,
      );
    }
  };

  const { data: companyDetails } = useGetCompanyDetails({ companyId: Number(companyId) });
  const canUseScautrAiAgent = isScautrAiAgentEnabled(companyDetails?.channels || []);

  return (
    <Tabs value={activeTab} onChange={handleTabChange}>
      <Tabs.List>
        <Tabs.Tab
          style={(theme) => ({
            border: `1px solid ${theme.colors.gray[3]}`,
            borderBottom: activeTab === 'model' ? `3px solid ${theme.colors.blue[5]}` : 'none',
          })}
          value="model"
        >
          기계모델 관리
        </Tabs.Tab>
        <Tabs.Tab
          style={(theme) => ({
            border: `1px solid ${theme.colors.gray[3]}`,
            borderBottom: activeTab === 'manual' ? `3px solid ${theme.colors.blue[5]}` : 'none',
          })}
          value="manual"
        >
          매뉴얼 관리
        </Tabs.Tab>
        {canUseScautrAiAgent && (
          <>
            <Tabs.Tab
              style={(theme) => ({
                borderRight: `1px solid ${theme.colors.gray[3]}`,
                borderTop: `1px solid ${theme.colors.gray[3]}`,
                borderBottom: activeTab === 'template' ? `3px solid ${theme.colors.blue[5]}` : 'none',
              })}
              value="template"
            >
              AS/CS 템플릿 관리
            </Tabs.Tab>
            <Tabs.Tab
              style={(theme) => ({
                borderRight: `1px solid ${theme.colors.gray[3]}`,
                borderTop: `1px solid ${theme.colors.gray[3]}`,
                borderBottom: activeTab === 'ascs' ? `3px solid ${theme.colors.blue[5]}` : 'none',
              })}
              value="ascs"
            >
              AS/CS 관리
            </Tabs.Tab>
          </>
        )}
      </Tabs.List>
    </Tabs>
  );
}
